import { useEffect } from 'react';
import Choices from 'choices.js';
import { Form } from 'react-bootstrap';
import { Field } from 'formik';
import 'choices.js/public/assets/styles/choices.min.css';
import '../../assets/styles/choices.scss';
import PropTypes from 'prop-types';

const MultipleSelectionInput = ({
  id,
  labelText,
  name,
  fromArray,
  formProps,
  requiredFiled = false,
}) => {
  useEffect(() => {
    // No need to use selectTeamMembers the render function, to remove the warning disabling no-unused-vars for this line
    // eslint-disable-next-line no-unused-vars
    const selectTeamMembers = new Choices(`#${id}`, {
      searchEnabled: true,
      delimiter: ',',
      removeItemButton: true,
    });
  }, [id]);
  let options;

  if (name.toLowerCase().indexOf('member') >= 0) {
    // @ToDo: Including Avatar image to <option> throws error while compiling, this has to be worked on later.
    options = fromArray.map((member) => (
      <option value={member.email} key={member.userId}>
        {member.firstName} {member.lastName}
      </option>
    ));
  } else if (name.toLowerCase().indexOf('project') >= 0) {
    options = fromArray.map((project) => (
      <option value={project._id} key={project._id}>
        {project.title}
      </option>
    ));
  }
  return (
    <Form.Group controlId="choices-multiple-default">
      <Form.Label>{labelText}</Form.Label>{' '}
      {requiredFiled && <span className="text-danger">*</span>}
      <Field
        as="select"
        id={id}
        name={name}
        multiple="multiple"
        className="form-select"
        onChange={(event) =>
          formProps.setFieldValue(
            name,
            [].slice
              .call(event.target.selectedOptions)
              .map((option) => option.value)
          )
        }
      >
        {options}
      </Field>
    </Form.Group>
  );
};

MultipleSelectionInput.propTypes = {
  id: PropTypes.string.isRequired,
  fromArray: PropTypes.array,
  name: PropTypes.string,
  labelText: PropTypes.string,
  formProps: PropTypes.any,
  requiredFiled: PropTypes.bool,
};

export default MultipleSelectionInput;
